'use strict'

import HttpWrapper from '@/modules/general/http'
import Exception from '@/modules/general/exception'
import router from '@/router'
import { EventBus } from "@/modules/event-bus"

const HttpModule = {
	install (Vue, options) {
		console.log('[Performance] HttpModule.install start')

		const http = HttpWrapper.create(options.HTTP_CONFIG)

		// client action 확인
		http.interceptors.request.use(config => {
			$('#loading').show();

			if (config.url != null && config.url.indexOf("/m/ai/") >= 0 && config.url != '/m/ai/aiLogout') {
				EventBus.$emit("ai-event-reaction")
			} else {
				if (config.url != null && config.url.indexOf("/login") < 0 && config.url != '/authnumber' && config.url != '/logout') {
					EventBus.$emit("event-reaction")
				}
			}

			return config
		}, (error) => {
			$("#loading").hide();
		});

		http.interceptors.response.use(response => {
			$("#loading").hide();

			var requestUrl = response.request.responseURL
			var httpStatus = response.status
			var data = response.data
			var result = null
			var isSuccess = true

			if (!data) {
				isSuccess = false
			}
			if (response.data) {
				result = response.data
				if (result.status !== options.HTTP_RESPONSE_SUCCESS
					&& result.status !== options.DUP_PK
					&& result.status !== options.DUP_REQ_PK) {
					isSuccess = false
				}
			}

			if (response.request.responseType === 'arraybuffer') {
				isSuccess = true
			}

			if (isSuccess === false) {
				return Promise.reject(
					new Exception.ApiResonseError(
						'[HTTP] Response Data is empty.',
						requestUrl,
						httpStatus,
						result
					)
				)
			}

			return response
		}, function (error) {
			$("#loading").hide();
			$("div[name=loading]").hide();

			if (error.response) {
				if (error.response.config.url.includes('/m/ai')) {
					if (error.response.status === 500) {
						if (error.response.data.status == options.NOT_LOGIN) {
							window.$AiAlert.alert('로그인 인증이 만료되었습니다.\n다시 로그인하여 주십시오.')
							.then(() => {
								window.$store
								.dispatch('Login/aiLogout')
								.then(() => {
									router.push('/ai');
								})
							})
						}
						// else if (error.response.data.status == options.UNAUTHORIZATION) {
						// 	window.$AiAlert.alert('권한이 없습니다.')
						// 	// api validation 오류
						// } else if (error.response.data.status == options.NOT_VALID_AGUMENT) {
						// 	window.$AiAlert.alert('validation 오
						// } else if (error.response.data.status == options.FILE_UPLOAD_FAIL) {
						// 	window.$AiAlert.alert('파일업로드 중 오류가 발생하였습니다.');
						// 	// 파일 다운로드 실패
						// } else if (error.response.data.status == options.FILE_DOWNLOAD_FAIL) {
						// 	window.$AiAlert.alert('파일다운로드 중 오류가 발생하였습니다.');
						// } else {
						// 	window.$AiAlert.alert('실행 중 오류가 발생하였습니다.<br/>잠시 후 다시 실행 해 주십시오.');
						// }
					}
				} else {
					if (error.response.status === 500) {
						// 로그인 오류
						if (error.response.data.status == options.NOT_LOGIN) {
							window.$Alert.alert('로그인 인증이 만료되었습니다.<br/>다시 로그인하여 주십시오.')
								.then(() => {
									window.$store
									.dispatch('Login/logout')
									.then(() => {
										router.push('/');
									})
								})
							// 권한 오류
						} else if (error.response.data.status == options.UNAUTHORIZATION) {
							window.$Alert.alert('권한이 없습니다.')
							// api validation 오류
						} else if (error.response.data.status == options.NOT_VALID_AGUMENT) {
							window.$Alert.alert('validation 오류 : <br/>'+ error.response.data.result.message)
							// 파일 업로드 실패
						} else if (error.response.data.status == options.FILE_UPLOAD_FAIL) {
							window.$Alert.alert('파일업로드 중 오류가 발생하였습니다.');
							// 파일 다운로드 실패
						} else if (error.response.data.status == options.FILE_DOWNLOAD_FAIL) {
							window.$Alert.alert('파일다운로드 중 오류가 발생하였습니다.');
						} else {
							window.$Alert.alert('실행 중 오류가 발생하였습니다.<br/>잠시 후 다시 실행 해 주십시오.');
						}
					}
				}
			} else if (error.config) {
				if (error.config.url.includes('/m/ai')) {
					window.$AiAlert.alert(error);
				} else {
					window.$Alert.alert(error);
				}
			} else {
				window.$Alert.alert(error);
			}

			return Promise.reject(error.response);
		})

		window.$http = http
		Vue.httpClient = http
		Vue.prototype.$http = http

		console.log('[Performance] HttpPlugin.install end')
	}
}

export default HttpModule


// WEBPACK FOOTER //
// ./src/modules/http.js